import { Button, CircularProgress, ThemeProvider } from "@mui/material";
import * as PropTypes from "prop-types";
import {
  buttontheme as buttonthemeDefault,
  buttonTheme2,
  buttonTheme3,
  buttonTheme4,
  buttonThemeOutlined,
} from "./component.styles";
function AppButton({
  title= "",
  sx= {},
  buttontheme = "dark",
  loading= false,
  endIcon= null,
  onClick= () => {},
  disabled= false,
  ...any
}) {

  const getTheme = (theme) => {
    switch (theme) {
      case "dark":
        return buttonthemeDefault;
      case "light":
        return buttonTheme2;
      case "transparent":
        return buttonTheme3;
      case "success":
        return buttonTheme4;
      case "outlined":
        return buttonThemeOutlined;
      default:
        return buttonthemeDefault;
    }
  };

  return (
    <ThemeProvider theme={getTheme(buttontheme)}>
      <Button
        {...any}
        onClick={onClick}
        disabled={disabled}
        loading={null}
        variant="contained"
        sx={{ width: "100%", ...sx, fontFamily: "manrope", color: buttontheme === 'light' && disabled ? '#F8FAFF' : '' }}
        endIcon={loading ? <CircularProgress size={20} style={buttontheme === 'light' ? { color: '#FFFFFF' } : {}} /> : endIcon}
      >
        {title}
      </Button>
    </ThemeProvider>
  );
}
AppButton.propTypes = {
  title: PropTypes.string,
  sx: PropTypes.object,
  buttontheme: PropTypes.string,
  loading: PropTypes.bool,
  endIcon: PropTypes.any,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
};
export default AppButton;
